import { SVGFilterStatus } from 'components/maps';

const SelectedFilter: React.FunctionComponent = () => {
  return (
    <filter id={`${SVGFilterStatus.SELECTED}`}>
      <feColorMatrix
        values='0 1 0 0 0
                0 0 0 0 0
                0 0 0 0 0
                0 0 0 1 0'
      />
      <feMorphology operator='dilate' radius={20} result='outlineMorph' />
      <feMerge>
        <feMergeNode in='outlineMorph' />
        <feMergeNode in='SourceGraphic' />
      </feMerge>
    </filter>
  );
};

export default SelectedFilter;
